import React from 'react';
import Sidebar from './Sidebar/index';

const SidebarSystem = ({ isOpen, onToggle, ...sidebarProps }) => {
    return (
        <>
            <div 
                className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
                onClick={() => onToggle(false)}
                aria-hidden={!isOpen}
            />
            
            <Sidebar isOpen={isOpen} {...sidebarProps} />
        </>
    );
};

export default SidebarSystem;